import { createFileRoute, Outlet, useParams } from '@tanstack/react-router'
import { InvestorRouteGuard } from '../../../contexts/investor-guard'
import { useInviteAcceptance } from '../../../hooks/use-invite-acceptance'

export const Route = createFileRoute('/app/investor/$id')({
  component: InvestorRoute,
})

/** Accepts `?invite=` on whichever investor page the link lands on, including ones that forward. */
function InviteAcceptance() {
  useInviteAcceptance()
  return null
}

function InvestorRoute() {
  const { id } = useParams({ from: '/app/investor/$id' })
  return (
    <InvestorRouteGuard investorId={id}>
      <InviteAcceptance />
      <Outlet />
    </InvestorRouteGuard>
  )
}
